import React from 'react';

import { Drawer, Typography } from '@mui/material';
import { useQuery } from 'react-query';

import notificationsApi from 'api/rest/notifications/notifications';
import { Notification } from 'api/rest/notifications/notifications.types';
import DrawerWrapper from 'components/DrawerWrapper/DrawerWrapper';
import Loader from 'components/Loader/Loader';
import NotificationCard from 'components/NotificationCard/NotificationCard';
import QUERY from 'constants/queryKeys';

import useStyles from './NotificationsDrawer.styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const NotificationsDrawer: React.FC<Props> = ({ isOpen, onClose }) => {
  // Full list only when the drawer is opened — not on mount/focus.
  const { data, isLoading } = useQuery(QUERY.GET_ALL_NOTIFICATIONS, notificationsApi.getAll(), {
    enabled: isOpen,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  const { classes } = useStyles();
  return (
    <Drawer onClose={onClose} open={isOpen} anchor='right'>
      <DrawerWrapper onClose={onClose} title='Powiadomienia'>
        <div className={classes.root}>
          {isLoading ? <Loader /> : null}
          {data && data?.map((notification: Notification) => <NotificationCard key={notification.id} {...notification} />)}
          {!isLoading && !data?.length ? (
            <Typography color='textSecondary' className={classes.noNotifications}>
              Brak powiadomień
            </Typography>
          ) : null}
        </div>
      </DrawerWrapper>
    </Drawer>
  );
};

export default NotificationsDrawer;
